import { useState, useCallback, memo } from 'react';
import { Switch } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { NationalModifiersDetails } from '@/types/nationalModifiers.types';
import { CustomTableMeta } from '@/components/Tables/TableCard/TableCard.types';

export const SwitchCell = memo(({ row, table, column }: CellContext<NationalModifiersDetails, unknown>) => {
  const { original } = row;
  const { isLock } = original;
  const { updateData } = table.options.meta as CustomTableMeta<NationalModifiersDetails>;
  const [checked, setChecked] = useState(isLock);

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      const saveIsLock = !checked;
      setChecked(saveIsLock);
      // Use immediate update for instant toggle feedback
      const updateFn = updateData as typeof updateData & {
        immediate?: (rowIndex: number, columnId: string, value: string | boolean) => void;
      };
      if (updateFn.immediate) {
        updateFn.immediate(row.index, column.id || '', saveIsLock);
      } else {
        updateData(row.index, column.id || '', saveIsLock);
      }
    },
    [checked, updateData, row.index, column.id],
  );

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      event.stopPropagation();
      const saveIsLock = event.target.checked;
      setChecked(saveIsLock);
      // Use immediate update for instant toggle feedback
      const updateFn = updateData as typeof updateData & {
        immediate?: (rowIndex: number, columnId: string, value: string | boolean) => void;
      };
      if (updateFn.immediate) {
        updateFn.immediate(row.index, column.id || '', saveIsLock);
      } else {
        updateData(row.index, column.id || '', saveIsLock);
      }
    },
    [updateData, row.index, column.id],
  );

  return (
    <Switch color="error" title="switch" checked={checked} onClick={handleClick} onChange={handleChange} size="small" />
  );
});

SwitchCell.displayName = 'SwitchCell';
